<div class="mask d-flex align-items-center justify-content-center" *ngIf="(authService.isLoggedIn$ | async) === false">  
    <div class="card col-lg-4 col-sm-12 dooya-yellow">
        <div class="card-body">
            <div class="text-center p-lg-5 w-100">       
                                
                <img src="../../../assets/img/DooyaThin.png" class="img-fluid" alt="Dooya" width="300px" />                
                <p class="h4 m-3">{{ pageHeader }}</p>

                    <ng-content></ng-content>

                <small>
                    <a href="https://www.dooya.co.za/terms" target="_blank">Terms of Service</a> and
                    <a href="https://www.dooya.co.za/policies" target="_blank"> Privacy Policy</a>
                </small>

            </div>
        </div>
    </div>
</div>
          
